import { type Account } from "@umami/chains";

export const getInitialAccounts = () => {
  const accounts = localStorage.getItem("persist:accounts");
  const nonEncryptedKeys = ["defaultAccount", "seedPhrases", "secretKeys"];

  return accounts
    ? JSON.parse(accounts, (key, value) =>
        nonEncryptedKeys.includes(key) ? JSON.parse(value) : value
      )
    : null;
};
export const getDefaultAccount = () => getInitialAccounts()?.defaultAccount || null;

export const getIsMnemonicAccountType = (account: Account) => account.type === "mnemonic";
export const getIsSecretKeyAccountType = (account: Account) => account.type === "secret_key";
